import React, { useRef, useState, useEffect } from 'react';
import styles from './PlayerIframe.module.css';

const PlayerIframe: React.FC<{ src: string }> = ({ src }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            const isCurrentlyFullscreen = !!(
                document.fullscreenElement ||
                (document as Document & { webkitFullscreenElement?: Element }).webkitFullscreenElement
            );
            setIsFullscreen(isCurrentlyFullscreen);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, []);

    const handleToggleFullscreen = () => {
        if (!containerRef.current) return;
        const el = containerRef.current as HTMLDivElement & { webkitRequestFullscreen?: () => void };

        if (isFullscreen) {
            if (document.exitFullscreen) document.exitFullscreen();
            else if ((document as Document & { webkitExitFullscreen?: () => void }).webkitExitFullscreen) {
                (document as Document & { webkitExitFullscreen?: () => void }).webkitExitFullscreen?.();
            }
        } else if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        }
    };

    return (
        <div className={styles.wrapper}>
            <div ref={containerRef} className={styles.container}>
                <iframe
                    src={src}
                    title="লাইভ স্পোর্টস স্ট্রিম"
                    className={styles.iframe}
                    allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                />
                <button
                    type="button"
                    onClick={handleToggleFullscreen}
                    className={styles.fullscreenBtn}
                    aria-label={isFullscreen ? 'ফুলস্ক্রিন বন্ধ' : 'ফুলস্ক্রিন'}
                >
                    {isFullscreen ? '⛶ বন্ধ' : '⛶ ফুলস্ক্রিন'}
                </button>
            </div>
        </div>
    );
};

export default PlayerIframe;
